import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useReveal } from '@/hooks/use-reveal'
import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    useReveal()

    return (
        <div className='flex min-h-screen flex-col overflow-x-clip'>
            <a
                href='#inhalt'
                className='sr-only rounded-full bg-signal-600 px-5 py-3 text-sm font-medium text-white focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60]'
            >
                Zum Inhalt springen
            </a>

            <Header />

            <main id='inhalt' tabIndex={-1} className='flex-1 focus-visible:outline-none'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
